import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  subscriptionActions,
  subscriptionSelectors
} from '../../../../store/modules/subscription';

const useRedeemCouponHandler = () => {
  const dispatch = useDispatch();
  const handler = useCallback(
    (code: string) => dispatch(subscriptionActions.redeemCoupon(code)),
    []
  );

  const submitError = useSelector(
    subscriptionSelectors.selectRedeemCouponError
  );

  return [handler, submitError?.message] as const;
};

export default useRedeemCouponHandler;
